module.exports = __webpack_public_path__ + "static/media/miscIcon.4ba5f48a.svg";